import React from "react";
import { Section, sectionSpacingY } from "components/section";
import { TextTitle, TextColumn } from "ui/text";
import { SimpleGrid } from "@chakra-ui/react";
import { ShoppingBagIcon, TrendIcon, HeartIcon, MegaphoneIcon, LeversIcon, PersonWithCheckIcon } from "ui/icons";

export function UseCaseGrid() {
  return (
    <Section my={0} py={sectionSpacingY}>
      <TextTitle
        align="center"
        size="lg"
        title="Give us your hardest lifecycle marketing problems. AI can help."
        maxW="860px"
      />

      <SimpleGrid
        columns={{ base: 1, md: 3 }}
        gap={{ base: "bigger", lg: "biggest" }}
        mt={{ base: "biggest", md: "huge" }}
      >
        <TextColumn
          iconChip={{
            variant: "yellow",
            icon: ShoppingBagIcon,
          }}
          title="Drive repeat purchases"
          description="Always recommend the next best product, at the right time, on the right channel."
        />
        <TextColumn
          iconChip={{ variant: "green", icon: TrendIcon }}
          title="Grow average order value"
          description="Optimize your offers so customers are receiving both the highest propensity and margin messages."
        />
        <TextColumn
          iconChip={{ variant: "red", icon: HeartIcon }}
          title="Improve customer experience"
          description="Give each customer 1:1 experiences that fit their unique journey, even if they’re not ready to buy."
        />
        <TextColumn
          iconChip={{ variant: "violet", icon: MegaphoneIcon }}
          title="Re-engage lapsed customers"
          description="Find the best way to bring each customer back to your business with the right offers and messages."
        />

        <TextColumn
          iconChip={{ variant: "blue", icon: PersonWithCheckIcon }}
          title="Increase engagement and loyalty"
          description="Retain more of your users by making sure they feel like you know them personally."
        />

        <TextColumn
          iconChip={{ variant: "yellow", icon: LeversIcon }}
          title="Cross-sell relevant products"
          description="Maximize your customer lifetime value by always sharing the next best product or service."
        />
      </SimpleGrid>
    </Section>
  );
}
